var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-list-group-item",
    { staticClass: "flex-column align-items-start" },
    [
      _c("div", { staticClass: "d-flex w-100 justify-content-between" }, [
        _c("span", { staticClass: "text-monospace" }, [
          _vm._v(_vm._s(_vm.apiKey.maskedKey)),
        ]),
        _c(
          "div",
          { staticClass: "d-flex" },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.apiKey.legacy,
                    expression: "apiKey.legacy",
                  },
                ],
              },
              [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover",
                        modifiers: { hover: true },
                      },
                    ],
                    staticClass: "ml-3",
                    staticStyle: { float: "right" },
                    attrs: {
                      "data-toggle": "tooltip",
                      "data-placement": "bottom",
                      title: _vm.$t("admin.old_key_format"),
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-exclamation-triangle status-warning",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
              ]
            ),
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover",
                    modifiers: { hover: true },
                  },
                ],
                staticClass: "action-icon ml-3",
                attrs: {
                  size: "sm",
                  title: _vm.$t("admin.regenerate_api_key_title"),
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("regenerateClicked")
                  },
                },
              },
              [_c("span", { staticClass: "fa fa-repeat" })]
            ),
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover",
                    modifiers: { hover: true },
                  },
                  {
                    name: "b-modal",
                    rawName: "v-b-modal",
                    value: `editApiKeyCommentModal-${_vm.keyId}`,
                    expression: "`editApiKeyCommentModal-${keyId}`",
                  },
                ],
                staticClass: "action-icon ml-3",
                attrs: {
                  size: "sm",
                  title: _vm.$t("admin.edit_api_key_comment"),
                },
              },
              [_c("span", { staticClass: "fa fa-edit" })]
            ),
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover",
                    modifiers: { hover: true },
                  },
                ],
                staticClass: "action-icon ml-3",
                attrs: { size: "sm", title: _vm.$t("admin.remove_api_key") },
                on: {
                  click: function ($event) {
                    return _vm.$emit("removeClicked")
                  },
                },
              },
              [_c("span", { staticClass: "fa fa-trash-o" })]
            ),
            _c("edit-api-key-comment-modal", {
              attrs: { "key-id": this.keyId, "api-key": this.apiKey },
            }),
          ],
          1
        ),
      ]),
      _c("p", { staticClass: "mt-2 font-weight-light" }, [
        _c("em", [_vm._v(_vm._s(_vm.comment))]),
      ]),
      _c("hr"),
      _c(
        "div",
        { staticClass: "d-flex w-100 justify-content-between text-muted" },
        [
          _c(
            "small",
            { attrs: { title: _vm.$t("admin.api_key_created_tooltip") } },
            [_vm._v("Created: " + _vm._s(_vm.createdTimestamp))]
          ),
          _c(
            "small",
            { attrs: { title: _vm.$t("admin.api_key_last_used_tooltip") } },
            [_vm._v("Last Used: " + _vm._s(_vm.lastUsedTimestamp))]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }